import React from "react";
import { Form, FormikProps } from "formik";
import { Grid } from "@mui/material";
import { InputWithErrorLabel as Input } from "components/haven-design/form/inputs";
import { SubmitButton } from "components/buttons";
import { CheckboxWithErrorLabel as Checkbox } from "components/haven-design/form/checkbox";
type QueryParams = {
  email: string;
  firstName: string;
  lastName: string;
  strict: boolean;
  includeIncomplete: boolean;
}

type FormProps = FormikProps<QueryParams>

const InterestSearchForm: React.FC<FormProps> = () => (
  <Form>
    <Grid container spacing={2} >
      <Grid size={{ md: 6 }}>
        <Input type="text" name="firstName" label="First Name" placeholder="First name" />
      </Grid>
      <Grid size={{ md: 6 }}>
        <Input type="text" name="lastName" label="Last Name" placeholder="Last name" />
      </Grid>
      <Grid size={{ md: 12 }}>
        <Input type="text" name="email" label="Email Address" />
      </Grid>
      <Grid size={{ md: 6 }}>
        <Checkbox name="strict" label="Exact results only" />
        <Checkbox name="includeIncomplete" label="Include incomplete applications" />
        <SubmitButton text="Search" />
      </Grid>
    </Grid>
  </Form>
);

export default InterestSearchForm;
